/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface QuartzJobHistory { 
    id?: number;
    job_name?: string;
    job_group?: string;
    description?: string;
    job_class_name?: string;
    trigger_name?: string;
    trigger_group?: string;
    state?: string;
    start_time?: Date;
    end_time?: Date;
    execution_time?: number;
    priority?: number;
    job_data?: string;
    interrupted?: boolean;
    misfired?: boolean;
    successfully_completed?: boolean;
    exception_details?: string;
    result?: string;
}

